import { StoreType } from '@tock/shared/utils/connect';

export const getToastSelector = (state: StoreType) => state.toast;
